
import { StyleEntry } from 'Shared/backend/styleUtils';
import { theme } from 'Shared/frontend/SettingsProvider';
import { stickyStyle } from 'Shared/frontend/nav/StandardNavWithLogo';

export function navStyles(sizes,text): {[name: string]: StyleEntry}
{
	return {
		'Fade in background': {
			explanation: 'Show the nav background when the page is not scrolled to the top.',

			rules: [{
				location: () => ['nav','desktop'],
				css: (_params, atTop: boolean) => ({
					...stickyStyle(),
					position: 'fixed',
					transition: 'background-color 0.7s',
					backgroundColor: atTop ? 'rgba(0,0,0,0)' : theme().nav.desktop.settings.outer.backgroundColor
				})
			}]
		},

		'Hide on desktop': {
			explanation: 'Hides the desktop navigation bar.',

			rules: [{
				location: () => ['nav','desktop'],
				hide: () => true
			}]
		},

		'Hide on mobile': {
			explanation: 'Hides the mobile navigation buttons.',

			rules: [{
				location: () => ['nav','mobile'],
				hide: () => true
			}]
		}
	};
}

